import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faEnvelope,
  faUnlockAlt,
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import BgImage from "../../assets/img/illustrations/signin.svg";
// import ReCAPTCHA from "react-google-recaptcha";
import { CSSTransition } from "react-transition-group";
import "animate.css"; // Import animate.css for animations
import "./Signin.css"; // Import animate.css for animations
import BASE_URL from "../../config";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("");
  const history = useHistory();
  // const [captchaToken, setCaptchaToken] = useState(null);
  // const recaptchaRef = useRef(null);
  const [captchaCode, setCaptchaCode] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  const captchaCanvasRef = useRef(null);

  const generateCaptcha = () => {
    const characters =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";

    let code = "";

    for (let i = 0; i < 6; i++) {
      code += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    setCaptchaCode(code);
    setCaptchaInput("");
  };

  
  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (!captchaCode || !captchaCanvasRef.current) {
      return;
    }

    const canvas = captchaCanvasRef.current;
    const ctx = canvas.getContext("2d");

    const width = 180;
    const height = 55;

    canvas.width = width;
    canvas.height = height;

    // =========================================
    // BACKGROUND
    // =========================================

    ctx.fillStyle = "#f4f4f4";
    ctx.fillRect(0, 0, width, height);

    // =========================================
    // RANDOM DOTS
    // =========================================

    for (let i = 0; i < 35; i++) {
      ctx.beginPath();

      ctx.arc(
        Math.random() * width,
        Math.random() * height,
        Math.random() * 1.5 + 0.5,
        0,
        Math.PI * 2
      );

      ctx.fillStyle = `rgba(80, 80, 80, ${
        Math.random() * 0.3
      })`;

      ctx.fill();
    }

    // =========================================
    // RANDOM LINES
    // =========================================

    for (let i = 0; i < 5; i++) {
      ctx.beginPath();

      ctx.moveTo(
        Math.random() * width,
        Math.random() * height
      );

      ctx.lineTo(
        Math.random() * width,
        Math.random() * height
      );

      ctx.strokeStyle = `rgba(60, 60, 60, ${
        Math.random() * 0.4 + 0.2
      })`;

      ctx.lineWidth = 1;

      ctx.stroke();
    }

    // =========================================
    // CAPTCHA CHARACTERS
    // =========================================

    const colors = [
      "#333333",
      "#444444",
      "#222222",
      "#555555",
      "#111111",
    ];

    for (let i = 0; i < captchaCode.length; i++) {
      const char = captchaCode[i];

      ctx.save();

      const x = 18 + i * 27;
      const y = 38;

      const rotation =
        (Math.random() - 0.5) * 0.5;

      ctx.translate(x, y);
      ctx.rotate(rotation);

      ctx.font = "bold 27px Arial";

      ctx.fillStyle =
        colors[
          Math.floor(Math.random() * colors.length)
        ];

      ctx.fillText(char, 0, 0);

      ctx.restore();
    }

    // =========================================
    // BORDER
    // =========================================

    ctx.strokeStyle = "#cccccc";
    ctx.lineWidth = 1;

    ctx.strokeRect(
      0,
      0,
      width,
      height
    );

  }, [captchaCode]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!captchaInput.trim()) {
      setError("Please enter the CAPTCHA.");
      return;
    }

    if (
      captchaInput.trim().toLowerCase() !==
      captchaCode.toLowerCase()
    ) {
      setError("Invalid CAPTCHA. Please try again.");
      generateCaptcha();
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/api.php`,
        {
          type: "login",
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );

      if (response.data.success) {
        localStorage.setItem("authToken", JSON.stringify(response.data.user));

        setModalMessage("You have logged in successfully!");
        setModalType("success");
        setShowModal(true);
      } else {
        setModalMessage(
          response.data.message ||
            "Login failed. Please check your credentials."
        );
        setModalType("error");
        setShowModal(true);
      }
    } catch (err) {
  console.error("LOGIN ERROR:", err);

  let message = "An error occurred during login. Please try again.";

  if (err.response) {
    console.error("STATUS:", err.response.status);
    console.error("DATA:", err.response.data);

    message =
      err.response.data?.message ||
      err.response.data?.error ||
      `Login failed. Server returned ${err.response.status}`;
  } else if (err.request) {
    console.error("NO RESPONSE FROM SERVER:", err.request);

    message =
      "Unable to connect to the server. Please check your API URL.";
  } else {
    console.error("REQUEST ERROR:", err.message);

    message = err.message;
  }

  setModalMessage(message);
    setModalType("error");
    setShowModal(true);
  }
  };

  // const handleCaptchaExecute = (token) => {
  //   setCaptchaToken(token);
  // };

  const handleModalClose = () => {
    setShowModal(false);
    if (modalType === "success") {
      history.push("/dashboard/overview");
    }
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <p className="text-center">
            <a
              href="https://blueberrymerchant.com/"
              className="text-gray-700"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to
              homepage
            </a>
          </p>
          <Row
            className="justify-content-center form-bg-image"
            style={{ backgroundImage: `url(${BgImage})` }}
          >
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Sign in to our platform</h3>
                </div>
                {error && <p style={{ color: "red" }}>{error}</p>}
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Your Email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="email"
                        placeholder="example@company.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Your Password</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        required
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  {/* <ReCAPTCHA
                    sitekey="6LfeTX4qAAAAAJBnTOh4_vWCbVs9o-8Z5uqoL6yF"
                    onChange={handleCaptchaExecute}
                    style={{ marginBottom: "20px" }}
                  /> */}
                  <div className="signin-captcha">

                    <div className="signin-captcha-wrapper">

                      <canvas
                        ref={captchaCanvasRef}
                        className="signin-captcha-image"
                        width="180"
                        height="55"
                      />

                      <Button
                        type="button"
                        variant="outline-secondary"
                        className="signin-captcha-refresh"
                        onClick={generateCaptcha}
                        title="Refresh CAPTCHA"
                      >
                        ↻
                      </Button>

                    </div>

                    <Form.Control
                      type="text"
                      placeholder="Enter CAPTCHA"
                      value={captchaInput}
                      onChange={(e) => {
                        setCaptchaInput(e.target.value);
                        setError("");
                      }}
                      autoComplete="off"
                      maxLength={6}
                      required
                    />

                  </div>
                  <Button variant="primary" type="submit" className="w-100">
                    Sign in
                  </Button>
                </Form>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    Not registered?
                    <Card.Link
                      as={Link}
                      to={"/examples/sign-up"}
                      className="fw-bold"
                    >
                      {` Create account `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Success/Error Modal with Animation */}
      <CSSTransition
        in={showModal}
        timeout={300}
        classNames={{
          enter: "animate__animated animate__zoomIn",
          exit: "animate__animated animate__zoomOut",
        }}
        unmountOnExit
      >
        <Modal
          show={showModal}
          onHide={handleModalClose}
          centered
          style={{ borderRadius: "10px", overflow: "hidden" }}
        >
          <Modal.Header
            closeButton
            className={`text-white ${
              modalType === "success" ? "bg-success" : "bg-danger"
            }`}
          >
            <Modal.Title>
              {modalType === "success"
                ? "🎉 Login Successful"
                : "❌ Login Failed"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="text-center p-4"
            style={{
              backgroundColor: modalType === "success" ? "#e9f7e9" : "#fdecea",
            }}
          >
            <div className="d-flex justify-content-center align-items-center mb-3">
              <FontAwesomeIcon
                icon={
                  modalType === "success" ? faCheckCircle : faExclamationCircle
                }
                className={`${
                  modalType === "success" ? "text-success" : "text-danger"
                } animate__animated animate__tada animate__infinite glowing-icon`}
                size="6x"
              />
            </div>
            <p
              className={`fw-bold ${
                modalType === "success" ? "text-success" : "text-danger"
              }`}
              style={{ fontSize: "1.2rem" }}
            >
              {modalMessage}
            </p>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant={modalType === "success" ? "success" : "danger"}
              onClick={handleModalClose}
              className="px-5 py-2 fw-bold"
              style={{ fontSize: "1rem", borderRadius: "25px" }}
            >
              {modalType === "success" ? "Go to Dashboard" : "Close"}
            </Button>
          </Modal.Footer>
        </Modal>
      </CSSTransition>
    </main>
  );
};

export default Signin;
